interface Node {
    wt: number
    pmu: number
    ct?: number
}

export const formatCallgraphNodeValue = (node: Node, memory: boolean, asDelta: boolean): string => {
    const units = memory
        ? [
              { dividedBy: 1024 * 1024 * 1024, label: 'GB' },
              { dividedBy: 1024 * 1024, label: 'MB' },
              { dividedBy: 1024, label: 'KB' },
          ]
        : [
              { dividedBy: 1000 * 1000 * 60, label: 'm' },
              { dividedBy: 1000 * 1000, label: 's' },
              { dividedBy: 1000, label: 'ms' },
          ]

    const lastUnit = units[units.length - 1]

    const prop = memory ? 'pmu' : 'wt'

    for (const unit of units) {
        if (Math.abs(node[prop]) >= unit.dividedBy) {
            if (unit.label === 'm') {
                if (node[prop] < 0) {
                    const minutes = Math.ceil(node[prop] / unit.dividedBy)
                    const seconds = Math.abs(Math.round((node[prop] / unit.dividedBy - minutes) * 60))

                    return formatValueWithSign(minutes, asDelta) + ' ' + unit.label + ' ' + formatValueWithSign(seconds, asDelta) + ' s'
                } else {
                    const minutes = Math.floor(node[prop] / unit.dividedBy)
                    const seconds = Math.round((node[prop] / unit.dividedBy - minutes) * 60)

                    return formatValueWithSign(minutes, asDelta) + ' ' + unit.label + ' ' + formatValueWithSign(seconds, asDelta) + ' s'
                }
            }

            const value = node[prop] / unit.dividedBy
            return formatValueWithSign(value, asDelta) + ' ' + unit.label
        }
    }

    if (lastUnit.label === 'm') {
        const minutes = Math.floor(node[prop] / lastUnit.dividedBy)
        const seconds = Math.round((node[prop] / lastUnit.dividedBy - minutes) * 60)

        return formatValueWithSign(minutes, asDelta) + ' ' + lastUnit.label + ' ' + formatValueWithSign(seconds, asDelta) + ' s'
    }
    const lastValue = node[prop] / lastUnit.dividedBy
    return formatValueWithSign(lastValue, asDelta) + ' ' + lastUnit.label
}

export const formatValueWithSign = (value: number, asDelta: boolean): string => {
    const digits = calculateDigits(value)
    const prunedValue = parseFloat(value.toFixed(Math.max(digits, 0))).toString()

    if (!asDelta) {
        return prunedValue
    }

    if (value === 0) {
        // there is -0 in JS, so Math.abs() is needed
        return '±' + Math.abs(value)
    }

    return value >= 0 ? '+' + prunedValue : prunedValue
}

const calculateDigits = (value: number): number => {
    return Math.max(3 - Math.max(Math.trunc(Math.abs(value)).toString().length, 0), 0)
}
